import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TextInput from "../common/formfields/TextInput"

const LoginForm = ({
    user,
    onLogin,
    onChange,
    processing = false,
    showTitle = true,
    errors = {}
}) => {
    return (
        <form onSubmit={onLogin}>
            {showTitle && <h2> Login</h2>}
            {errors.onProcessingLogin && (
                <div className="alert alert-danger" role="alert">
                    {errors.onProcessingLogin}
                </div>
            )}

            <TextInput
                name="username"
                label="Username or Email"
                type="text"
                value={user.username}
                onChange={onChange}
                error={errors.username}
            />

            <TextInput
                name="password"
                label="Password"
                type="password"
                value={user.password}
                onChange={onChange}
                error={errors.password}
            />

            <button type="submit" disabled={processing} className="btn btn-info float-right">
                {processing ? "Logging in..." : "Log in"}
            </button>
        </form>
    );
}

LoginForm.propTypes = {
    user: PropTypes.object.isRequired,
    errors: PropTypes.object,
    onLogin: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    processing: PropTypes.bool
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/user/LoginForm.js